import React, { useMemo } from 'react'

import { getTypeformUrl, KEY_REPORT_INVOICE } from '@/core/api/data/typeforms'
import { useTranslation } from '@/core/i18n/useTranslation'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/shared/components/molecules/Dialog/dialog'
import { useCurrentAccount } from '@/shared/hooks/useCurrentAccount'

interface ReportInvoiceModalProps {
	isOpen: boolean
	onClose: () => void
	invoiceId?: number | string
}

const ReportInvoiceModal: React.FC<ReportInvoiceModalProps> = ({
	isOpen,
	onClose,
	invoiceId,
}) => {
	const { t, currentLanguage } = useTranslation('common')

	const currentAccount = useCurrentAccount()

	const accountType = currentAccount?.accountType || 'brandtrack'
	const normalizedLanguage =
		currentLanguage?.split('-')[0]?.toLowerCase() || 'en'

	const typeformUrl = useMemo(() => {
		return getTypeformUrl(KEY_REPORT_INVOICE, normalizedLanguage, accountType, {
			invoice_id: invoiceId,
		})
	}, [normalizedLanguage, accountType, invoiceId])

	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent className="max-w-4xl w-full h-[90vh] p-0">
				<DialogHeader className="p-6 pb-0">
					<DialogTitle>{t('account.billing.invoice_menu.upload')}</DialogTitle>
				</DialogHeader>
				<div className="flex-1 min-h-[80vh] p-6 pt-0">
					{typeformUrl ? (
						<iframe
							src={typeformUrl}
							width="100%"
							height="100%"
							className="border-0 rounded-lg"
							title={t('account.billing.invoice_menu.upload')}
						/>
					) : (
						<div className="flex items-center justify-center h-full text-content-tertiary">
							{t('common.error_loading_form')}
						</div>
					)}
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default ReportInvoiceModal
